import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { DevBar, Collection } from '@eti/debug';
import { analytics } from '@eti/utils';
import { useSiteContext, useSnowplowTracking } from '@eti/providers';
import { getAllKindsOfCarrierCodes } from '../../../utils/carriersUtils';
import { isDev } from '../../../common/debug/utils';
import { DebugCommonComponents } from '../../../common/debug/components';
import { useSkyscannerOrderTracking } from '../../../common/tracking/skyscannerTracking';
import Receipt from './Receipt';

const ReceiptPage = ({ gaData, gfData, ...props }) => {
  const { isSnowplowTrackingEnabled, sendTrackEvent, updateSnowplowContextData } =
    useSnowplowTracking();
  analytics.useGADataLayerEffect({ event: 'orderEvent', ...gaData });

  const { isCreatingOrder, isPostBookingOrder } = props;
  useEffect(() => {
    if (isCreatingOrder && !isPostBookingOrder) {
      analytics.pushEntryToDataLayer({ event: 'EcomPurchase' });
    }
  }, [isCreatingOrder, isPostBookingOrder]);

  useEffect(() => {
    if (isSnowplowTrackingEnabled) {
      const { marketingCarrierCodes, operatingCarrierCodes, ticketingCarrierCodes } =
        getAllKindsOfCarrierCodes(props.bounds);

      updateSnowplowContextData({
        flightData: {
          marketingCarrierCodes,
          operatingCarrierCodes,
          validatingCarrierCodes: ticketingCarrierCodes,
        },
      });

      sendTrackEvent({
        category: 'Order Confirmation',
        action: 'Seen',
        label: 'Page',
      });
    }
  }, [props.bounds, isSnowplowTrackingEnabled, sendTrackEvent, updateSnowplowContextData]);

  useEffect(() => {
    const hasGtagFunction = typeof window.gtag === 'function';
    const hasPartnerId = window.spa_variables?.googleFlightsPartnerId;

    if (hasGtagFunction && hasPartnerId) {
      window.gtag('event', 'purchase', gfData);
    }
  }, [gfData]);

  useSkyscannerOrderTracking(props);

  const { language } = useSiteContext();

  return (
    <>
      <Receipt {...props} language={language} />
      {isDev && (
        <DevBar>
          <Collection>
            <DebugCommonComponents />
          </Collection>
        </DevBar>
      )}
    </>
  );
};

ReceiptPage.propTypes = {
  bounds: PropTypes.arrayOf(PropTypes.any),
  gaData: PropTypes.objectOf(PropTypes.any),
  gfData: PropTypes.objectOf(PropTypes.any),
  isCreatingOrder: PropTypes.bool,
  isPostBookingOrder: PropTypes.bool,
};

export default ReceiptPage;
